<template>
  <TemplateDemandBooking3 />
</template>

<script>
import TemplateDemandBooking3 from "@/views/Templates/Demand/TemplateDemandBooking3";
import { onMounted } from "vue";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "Booking3",
  components: {
    TemplateDemandBooking3,
  },
  setup() {
    onMounted(async () => {
      nativeHandlerService.demand.ncSetDemandIndex(3);
    });
  },
};
</script>
